import { useState } from 'react';
import './EnquiryForm.css';

const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xlgvlaaw';

export default function EnquiryForm({ defaultSessions = '' }) {
  const [form, setForm] = useState({ name: '', phone: '', email: '', sessions: defaultSessions, dates: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name,
          phone: form.phone,
          _replyto: form.email,
          sessions: form.sessions,
          dates: form.dates,
          message: form.message,
        }),
      });
      if (res.ok) {
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className="pb-sent">
        <p>Thank you – we've received your enquiry and will be in touch soon!</p>
      </div>
    );
  }

  return (
    <form className="pb-form" onSubmit={handleSubmit} noValidate>
      <div className="pb-form-row">
        <label className="pb-label">
          Name *
          <input className="pb-input" name="name" type="text" required value={form.name} onChange={handleChange} placeholder="Your name" />
        </label>
        <label className="pb-label">
          Phone
          <input className="pb-input" name="phone" type="tel" value={form.phone} onChange={handleChange} placeholder="Your phone number" />
        </label>
      </div>
      <label className="pb-label">
        Email *
        <input className="pb-input" name="email" type="email" required value={form.email} onChange={handleChange} placeholder="Your email address" />
      </label>
      <label className="pb-label">
        Preferred sessions
        <input className="pb-input" name="sessions" type="text" value={form.sessions} onChange={handleChange} placeholder="e.g. Urban Foraging, Botanical Skincare" />
      </label>
      <label className="pb-label">
        Preferred dates or timeframe
        <input className="pb-input" name="dates" type="text" value={form.dates} onChange={handleChange} placeholder="e.g. July 2026, weekends preferred" />
      </label>
      <label className="pb-label">
        Anything else we should know
        <textarea className="pb-input pb-textarea" name="message" value={form.message} onChange={handleChange} placeholder="Group size, location, occasion, accessibility needs…" rows={4} />
      </label>
      {status === 'error' && (
        <p className="pb-form-error">Something went wrong – please try again or email us directly at <a href="mailto:thesubtleanimal@gmail.com">thesubtleanimal@gmail.com</a>.</p>
      )}
      <button type="submit" className="btn pb-submit-btn" disabled={status === 'submitting'}>
        {status === 'submitting' ? 'Sending…' : 'Send Enquiry'}
      </button>
    </form>
  );
}
